import ModalContainer from "../../Componant/Ui Kit/Modal";

const Modal = () => {
  return (
    <div className="page-body">
      <ModalContainer />
    </div>
  );
};

export default Modal;
